import { initializeApp } from "firebase/app";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: `${import.meta.env.VITE_FIREBASE_PROJECT_ID}.firebaseapp.com`,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: `${import.meta.env.VITE_FIREBASE_PROJECT_ID}.appspot.com`,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export async function signInWithGoogle() {
  try {
    console.log("Starting Google sign in process...");
    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    console.log("Google sign in successful, sending to backend...");

    // Send the Google user info to our backend to create/update the user
    const response = await fetch("/api/auth/google", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        uid: user.uid,
        email: user.email,
        displayName: user.displayName,
        photoURL: user.photoURL,
      }),
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      throw new Error("Server returned non-JSON response");
    }

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Authentication failed");
    }

    return await response.json();
  } catch (error: any) {
    console.error("Error signing in with Google:", error);

    if (error.code === "auth/unauthorized-domain") {
      throw new Error(
        `Unauthorized domain. Please ensure ${window.location.hostname} is added to Firebase Console's Authorized Domains.`
      );
    }
    if (error.code === "auth/configuration-not-found") {
      throw new Error("Firebase configuration error. Please check your Firebase configuration.");
    }
    throw error;
  }
}

export async function signOut() {
  try {
    await auth.signOut();
    // Also sign out from our backend
    const response = await fetch("/api/auth/logout", {
      method: "POST",
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Logout failed");
    }

    return response.json();
  } catch (error) {
    console.error("Error signing out:", error);
    throw error;
  }
}

export { auth };